export const createFrame = (
  iFrameUrl: string,
  iFrameId: string,
  isSrcDocUsed: boolean,
) => {
  const iFrame: HTMLIFrameElement = document.createElement('iframe');
  iFrame.setAttribute('id', iFrameId);
  if (isSrcDocUsed) {
    iFrame.setAttribute('srcdoc', `${iFrameUrl}`);
  } else {
    iFrame.setAttribute('src', `${iFrameUrl}`);
  }
  iFrame.setAttribute('frameborder', '0');
  iFrame.setAttribute('height', '1');
  iFrame.setAttribute('width', '1');
  return iFrame;
};
